import * as React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { localizations } from '../../localization/localization';
import { Control, Form, Errors } from 'react-redux-form';
import { TruckModel } from '../TruckModels';
import { DialogPropsBase } from '../../common/props/commonFormProps';
import FormItem from '../../components/forms/FormItem';
import { renderMultilineTextField } from '../../common/forms/FieldCreators';
import { connect } from 'react-redux';
import * as validators from '../../common/validators/formValidators'
import { renderNewTextField, renderErrorInfoText } from '../../common/forms/FieldCreators';

type SubmitType = (values: any) => void;
type CancelType = () => void;

interface TruckEmailDialogProps extends DialogPropsBase<SubmitType, CancelType> {
    truck: TruckModel;
    toReporter: boolean;
}

interface TruckEmailState {
    message: string;
    emailAddress: string;
}

class TruckEmailDialog extends React.Component<TruckEmailDialogProps, TruckEmailState> {
    constructor(props: TruckEmailDialogProps) {
        super(props);
        this.state = {
            message: '',
            emailAddress: ''
        };
    }

    public render() {
        const { isOpen, toReporter } = this.props;
        return (
            <Dialog maxWidth="lg" open={isOpen}>
                <Form model="infoEmail" onSubmit={this.props.onSubmit}>
                    <DialogTitle title={toReporter ? localizations.trucks.actions.sendEmailToAdvertiser : localizations.trucks.actions.sendDetailsViaEmail}>
                        {toReporter ? localizations.trucks.actions.sendEmailToAdvertiser : localizations.trucks.actions.sendDetailsViaEmail}
                    </DialogTitle>
                    {toReporter ? (
                        <DialogContent>
                            <FormItem>
                                <Control.text id="message" model=".message" validators={{ required: validators.required }} component={renderMultilineTextField} label= {localizations.trucks.actions.noteForAdvertiser} />
                            </FormItem>
                            <Errors model={".message"} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                        </DialogContent>
                    ) : (
                        <DialogContent>
                            <FormItem>
                                <Control.text id="email-address" model=".emailAddress" validators={{ required: validators.required }} component={renderNewTextField} label={localizations.trucks.actions.recipientEmail}/>
                            </FormItem>
                            <Errors model={".emailAddress"} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                            <FormItem>
                                <Control.text id="message" model=".message" validators={{ required: validators.required }} component={renderMultilineTextField} label={localizations.trucks.actions.noteForRecipient} />
                            </FormItem>
                            <Errors model={".message"} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                        </DialogContent>
                    )}
                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={this.props.onCancel}>{localizations.actions.cancel}</Button>
                        <Button variant="contained" color="secondary" type="submit">{localizations.actions.send}</Button>
                    </DialogActions>
                </Form>
            </Dialog>
        );
    }
}

const mapStateToProps = () => {
    return { }
}

export default connect<any, any, any>(mapStateToProps)(TruckEmailDialog);


// WEBPACK FOOTER //
// ./src/trucks/forms/TruckEmailDialog.tsx